module.exports = __webpack_public_path__ + "assets/c814f9df9a16c31cea9ec30455843ee6.svg";